import { DynamicDetails } from "@/components/DynamicDetails/DynamicDetails";
import * as S from "@/containers/Project/components/styled";
import { FormType } from "@/enums";
import { routes } from "@/helpers";
import { useFormPropertyProvider, useProjectContext } from "@/providers";
import { Button } from "antd";
import { bool } from "prop-types";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

const ProjectDetailsCard = ({ open }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { getFormProperties } = useFormPropertyProvider();
  const { project } = useProjectContext();

  const onViewClick = () => {
    navigate(routes.projects.intakeView(project.id));
  };

  const formConfig = getFormProperties(FormType.Intake);

  return (
    <S.DetailsCard
      $open={open}
      actions={[
        <Button
          key="1"
          onClick={onViewClick}
          data-test-id="project-details-card-view-button"
          type="primary"
        >
          {intl.formatMessage({ id: "project.view" })}
        </Button>,
      ]}
    >
      <DynamicDetails
        formConfig={formConfig}
        data={project}
        formType={FormType.Intake}
      />
    </S.DetailsCard>
  );
};

ProjectDetailsCard.propTypes = {
  open: bool,
};

export { ProjectDetailsCard };
